import FemaleAssistant from "../../assets/images/female_assistant.webp";
import SpecialisedFields from "../../assets/images/specialised_fields.webp";
import ProspectClients from "../../assets/images/prospect_clients.webp";
import {useEffect} from 'react'
import AOS from 'aos';
import 'aos/dist/aos.css';


const HeroImage = () => {
  useEffect(() => {
    AOS.init({duration: 500})
  }, [])

  return (
    <div className="bg-white mt-18 pt-24 lg:pt-0 lg:mt-0 flex justify-center w-full lg:bg-opacity-0">
      <div className="relative">
        <div className="absolute top-20 sm:top-32 left-0 sm:left-24 z-1">
          <svg
            className="top-0 left-44  absolute -mt-8"
            width="155"
            height="155"
            viewBox="0 0 155 155"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="77.5"
              cy="77.5"
              r="75"
              stroke="#2F6DCF"
              strokeWidth="5"
            />
          </svg>

          <div className="relative flex flex-col items-end">
            <img
              data-aos="fade-left"
              className="w-60"
              src={SpecialisedFields}
              alt=""
            />
            <img
              data-aos="fade-left"
              className="w-60 mt-4 lg:mt-12 xl:mt-18 2xl:mt-24"
              src={ProspectClients}
              alt=""
            />
          </div>
        </div>
        <img
          // data-aos="flip-left"
          // data-aos-mirror='true'
          className="relative z-4"
          style={{ width: "664px" }}
          src={FemaleAssistant}
          alt=""
        />
      </div>
    </div>
  );
};

export default HeroImage;
